import { leafPaths, getAt } from './setAt';

// Which dotted paths differ between the buffer being edited and the spec it was duplicated from.
//
// The dominant authoring task is not writing a spec from scratch — it is duplicating one as _v2
// and changing three fields. Naming those three, and letting every byte-identical section stay
// collapsed, is the whole read path for that task.

const sameValue = (a, b) => {
  if (a === b) return true;
  if (a === undefined || b === undefined) return false;
  if (a === null || b === null) return a === b;
  if (typeof a === 'object' || typeof b === 'object') return JSON.stringify(a) === JSON.stringify(b);
  return false;
};

// Returns the union of leaf paths in either tree whose values differ. A path present in one and
// absent in the other counts as changed.
export const diffPaths = (current, origin) => {
  if (!origin || !current) return [];

  const seen = {};
  const paths = [];
  leafPaths(current)
    .concat(leafPaths(origin))
    .forEach((p) => {
      if (p && !seen[p]) {
        seen[p] = true;
        paths.push(p);
      }
    });

  return paths.filter((path) => !sameValue(getAt(current, path), getAt(origin, path)));
};

// The sub-object (or 'identity') each changed path belongs to, so a panel can render
// "3 changes from v1" and the unchanged ones can say so.
export const changesBySection = (current, origin) => {
  const bySection = {};
  diffPaths(current, origin).forEach((path) => {
    const head = path.split('.')[0];
    const section =
      ['trigger', 'document_set', 'score_gen', 'output_extraction'].indexOf(head) > -1 ? head : 'identity';
    bySection[section] = (bySection[section] || []).concat(path);
  });
  return bySection;
};
